import React, { useState, useEffect, useCallback } from 'react';

import { Row, Column } from 'components/Layout/Grid';
import { Button } from 'components/Button';
import Select from 'components/Select';
import Text from 'components/Text';
import Form from 'components/Form';

import IconSearch from 'img/search-icon.svg';

import { CteStockTableSearchProps } from './interface';

import { DateOutputStr } from 'utils/DateOutput';
import DomainSettingService from 'services/domainSetting.service';
import { IDomainSetting } from 'models/DomainSetting';
import { IBatchRequestResponse } from 'models/Batch';

import { DivStopWatch } from './styles';

export const CteStockTableSearch: React.FC<CteStockTableSearchProps> = (props) => {
  const {
    setTableFilter,
    className,
    setCurrentPage,
    integrationUpdatedDate
  } = props;

  const _domainSettingService = new DomainSettingService();

  const randomTableSearchId = `${Math.random() * 1000}`;

  const [searchStr, setSearchStr] = useState("");
  const [expirationDateSelected, setExpirationDateSelected]: any = useState(null);

  const [expirationDateOption, setExpirationDateOption] = useState([]);

  useEffect(() => {
    _domainSettingService
      .get(undefined, undefined, 'value asc', {
        and: [
          { identifier: { eq: 'CteStockExpirationDate' } },
          { enabled: { eq: true } },
        ],
      })
      .then((result: IBatchRequestResponse<IDomainSetting> | undefined) => {
        if (result && result.data) {
          const { value } = result?.data?.[0];
          setExpirationDateOption(JSON.parse(value || ''));
        }
      });
  }, []);

  const makeFilter = useCallback(() => {
    setCurrentPage(0);
    setTableFilter({
      expirationDate: expirationDateSelected,
      searchProduct: searchStr
    });
  }, [expirationDateSelected, searchStr]);

  return (
    <Form id="table-search-cte" onValidate={makeFilter}>
      <Row
        id={randomTableSearchId}
        tabIndex={0}
        className={`mt-4 align-center flex-md-column align-md-none flex-wrap justify-md-none bg-white ${className || 'px-3 py-3'}`}
        style={{ borderRadius: '10px 10px 0px 0px' }}
      >
        <Column className="mr-2 mr-md-2 w-md-100 ajustment-filter">
          <Text className="mb-1 color-blue-gray" size={12} weight="bold">
            Filtro
          </Text>

          <Row>
            <input
              onChange={(e) => setSearchStr(e.target.value)}
              type="text"
              placeholder="Código ou nome do produto"
              value={searchStr}
              className="w-sm-100 w-md-100"
            />
          </Row>

        </Column>

        <Column className="mr-2 mr-md-2 category-reason">
          <Text size={12} className="mt-md-4 mb-1 color-blue-gray mb-lg-1 mr-2">
            Validade
          </Text>
          <Row className="align-center flex-sm-column">
            <Select
              stateName="protocolCategory"
              onChange={(e) => setExpirationDateSelected(e.target.value)}
              name="Validade"
              id="PROTOCOL_CATEGORY"
              value={expirationDateSelected}
              options={expirationDateOption}
              width="180px"
              isFilterProtocols
            />
          </Row>
        </Column>

        <Column className="mr-2 mt-md-3 w-md-100 pt-3 pt-md-0 ajustment-button">
          <Row>
            <Button
              tabIndex={0}
              className="focus-button"
              width="auto"
              onClick={makeFilter}
            >
              <img src={IconSearch} alt="" />
            </Button>
          </Row>
        </Column>

        <DivStopWatch className="flex-1 w-md-100">
          Última atualização {DateOutputStr(integrationUpdatedDate, 'hh:mm')} {'\n'}
        </DivStopWatch>
      </Row>
    </Form>
  );
};